export default "__VITE_ASSET__DxhI1YWn__"